import { TOUR_TRANSLATIONS } from './tourTranslations';

// helper - return translation by key + language
const t = (lang, key) =>
  (TOUR_TRANSLATIONS[lang] && TOUR_TRANSLATIONS[lang][key]) || TOUR_TRANSLATIONS['en-US'][key];

export const ROUTE_TOURS = {
  '/': (lang) => [
    {
      id: 'create_application_button',
      target: '.create_application_button',
      content: t(lang, 'create_application_button'),
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      id: 'pre_lodgement_button',
      target: '.pre_lodgement_button',
      content: t(lang, 'pre_lodgement_button'),
      disableBeacon: true,
      placement: 'right',
    },
    {
      id: 'final_lodgement_button',
      target: '.final_lodgement_button',
      content: t(lang, 'final_lodgement_button'),
      disableBeacon: true,
      placement: 'right',
    },
    {
      id: 'language_dropdown',
      target: '.language_dropdown',
      content: t(lang, 'language_dropdown'),
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      id: 'application_card',
      target: '.application_card',
      content: t(lang, 'application_card'),
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      id: 'application_card_details',
      target: '.application_card_details',
      content: t(lang, 'application_card_deatils'),
      disableBeacon: true,
      placement: 'left',
    },
    {
      target: '.pagination_next_button',
      content: t(lang, 'pagination_next_button'),
      disableBeacon: true,
      placement: 'top',
    },
    {
      target: '.pagination_prev_button',
      content: t(lang, 'pagination_prev_button'),
      disableBeacon: true,
      placement: 'top',
    },
  ],

  '/mapView': (lang) => [
    {
      target: '.slider_toggle',
      content: t(lang, 'slider_toggle'),
      disableBeacon: true,
      placement: 'right',
    },
    {
      target: '.map_control',
      content: t(lang, 'map_control'),
      disableBeacon: true,
      placement: 'top',
    },
    {
      target: '.legend_control',
      content: t(lang, 'legend_control'),
      disableBeacon: true,
      placement: 'top',
    },
    {
      target: '.add_overlay',
      content: t(lang, 'add_overlay'),
      disableBeacon: true,
      placement: 'top',
    },
    {
      target: '.draw_control',
      content: t(lang, 'draw_control'),
      disableBeacon: true,
      placement: 'left',
    },
    {
      target: '.import_plan_control',
      content: t(lang, 'import_plan_control'),
      disableBeacon: true,
      placement: 'left',
    },
    {
      target: '.screenshot-button',
      content: t(lang, 'screenshot_button'),
      disableBeacon: true,
      placement: 'left',
    },
    {
      target: '.capture_screenshot_button',
      content: t(lang, 'capture_screenshot_button'),
      disableBeacon: true,
      placement: 'left',
    },
  ],

  '/documentUpload': (lang) => [
    {
      target: '.upload_section',
      content: t(lang, 'upload_section'),
      disableBeacon: true,
    },
  ],
};
